import { useTranslation } from 'react-i18next';

import { env } from '~/lib/env';

export function EmbeddedWelcomePage() {
  const { t } = useTranslation('wmgone');

  return (
    <div className="flex h-[calc(100vh-80px)] flex-col gap-sm">
      <div className="font-dazzed text-[7em] font-bold text-tertiary-default">
        <h2>{t('static-page.wmgOne')}</h2>
      </div>
      <iframe
        src={env('VITE_WMG_HOMEPAGE_EMBED_URL')}
        aria-label="embedded-homepage-content"
        style={{
          // https://stackoverflow.com/questions/5867985/full-screen-iframe-with-a-height-of-100
          overflow: 'hidden',
          height: '100%',
          width: '100%',
          border: 'none',
        }}
      />
    </div>
  );
}

EmbeddedWelcomePage.displayName = 'EmbeddedWelcomePage';
